<ridango-dialog [size]="'460'" [visible]="true" (onClose)="closeDialog()">
    <div class="dialog-title bold">
        {{ 'YOUR_BASKET' | translate }}
    </div>

    <div class="dialog-description">
        <p>{{ 'YOUR_TICKETS' | translate }}</p>

        <p>{{ 'REMOVE_TICKETS' | translate }}</p>
    </div>

    <div class="dialog-buttons-area">
        <div class="dialog-buttons-area__right">
            <button
                class="btn btn--primary btn--maximal"
                (click)="goToCart()"
                (keydown.enter)="goToCart()"
                (keydown.space)="goToCart()">
                {{ 'GO_TO_CART' | translate }}
            </button>
        </div>

        <div class="dialog-buttons-area__left">
            <a
                class="link link--action link--emphasized"
                #focus
                (click)="closeDialog()"
                (keydown.enter)="closeDialog()"
                (keydown.space)="closeDialog()"
                tabindex="0"
                >{{ 'CANCEL' | translate }}</a
            >
        </div>
    </div>
</ridango-dialog>
